/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Analysis_Step2Inputs */

const en_gc_resources_guide_analysis_step2 = /** @type {(inputs: Gc_Resources_Guide_Analysis_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select A1:B4 and use the chart command from the toolbar or Insert menu. Choose a column chart, then check that the amounts and category labels match the cells.`)
};

const zh_gc_resources_guide_analysis_step2 = /** @type {(inputs: Gc_Resources_Guide_Analysis_Step2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择 A1:B4，使用工具栏或插入菜单中的图表命令。选择柱状图，检查金额与分类标签是否与单元格一致。`)
};

/**
* | output |
* | --- |
* | "Select A1:B4 and use the chart command from the toolbar or Insert menu. Choose a column chart, then check that the amounts and category labels match the cells." |
*
* @param {Gc_Resources_Guide_Analysis_Step2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_analysis_step2 = /** @type {((inputs?: Gc_Resources_Guide_Analysis_Step2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Analysis_Step2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_analysis_step2(inputs)
	return zh_gc_resources_guide_analysis_step2(inputs)
});
export { gc_resources_guide_analysis_step2 as "gc.resources.guide.analysis.step2" }